import { BusinessData } from "../../../types";

export const searchCompanies = (businesses: BusinessData[], query: string): BusinessData[] => {
  const normalizedQuery = query?.toLowerCase().trim();
  if (normalizedQuery === "") {
    return businesses;
  }
  return businesses.filter((business) => {
    const nameMatches = business.businessBasic.name.toLowerCase().includes(normalizedQuery);
    const address = business.businessBasic.address;
    const locationMatches = address.toLowerCase().includes(normalizedQuery);

    const matchingBookingTypes = business.businessBookingTypes.filter((bookingType) =>
        bookingType.title.toLowerCase().includes(normalizedQuery)
    );

    return nameMatches || locationMatches || matchingBookingTypes.length > 0;
}).map((business) => ({
    ...business,
    businessBookingTypes: business.businessBookingTypes.filter((bookingType) =>
        bookingType.title.toLowerCase().includes(normalizedQuery)
    )
}));
};